import {
  CellStyleModule,
  ColumnApiModule,
  ColumnAutoSizeModule,
  ColumnMenuModule,
  EventApiModule,
  LocaleModule,
  ModuleRegistry,
  RenderApiModule,
  RowApiModule,
  RowGroupingModule,
  RowStyleModule,
  ScrollApiModule,
  ServerSideRowModelApiModule,
  ServerSideRowModelModule,
  TooltipModule,
  ValidationModule,
} from 'ag-grid-enterprise';

/**
 * Modules for the server-side (SSRM) tree-table. `ServerSideRowModelModule` +
 * `RowGroupingModule` provide the lazy tree-data behaviour; the rest mirror the
 * subset the client-side grid registers. `ModuleRegistry` is global and
 * deduped, so this coexists with `ControlledAGGrid`'s registration.
 */
export const registerServerSideModules = () => {
  ModuleRegistry.registerModules([
    ServerSideRowModelModule,
    ServerSideRowModelApiModule,
    RowGroupingModule,
    CellStyleModule,
    RowStyleModule,
    RenderApiModule,
    RowApiModule,
    EventApiModule,
    TooltipModule,
    ColumnApiModule,
    ColumnAutoSizeModule,
    ColumnMenuModule,
    ScrollApiModule,
    LocaleModule,
  ]);
  if (import.meta.env.DEV) {
    ModuleRegistry.registerModules([ValidationModule]);
  }
};
